import { render, staticRenderFns } from "./TabContentDynamic.vue?vue&type=template&id=014968de"
import script from "./TabContentDynamic.vue?vue&type=script&lang=js"
export * from "./TabContentDynamic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('014968de')) {
      api.createRecord('014968de', component.options)
    } else {
      api.reload('014968de', component.options)
    }
    module.hot.accept("./TabContentDynamic.vue?vue&type=template&id=014968de", function () {
      api.rerender('014968de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/require/components/TabContentDynamic.vue"
export default component.exports